var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('h4',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{style:('background: #ececec; width: 100%; height: ' + _vm.extra.height + 'px;'),attrs:{"id":"map"}})])}
var staticRenderFns = []

export { render, staticRenderFns }